<div class="removable-chip">
    <span class="removable-chip__label">{{ label() }}</span>
    <button type="button" class="removable-chip__button" (click)="onRemove()" aria-label="Remove">
        <svg width="10" height="10">
            <use [attr.href]="spritePath + '#' + icons.close"></use>
        </svg>
    </button>
</div>
